import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translations
import enNav from './locales/en/nav.json';
import zhNav from './locales/zh/nav.json';
import enAuth from './locales/en/auth.json';
import zhAuth from './locales/zh/auth.json';
import enAccount from './locales/en/account.json';
import zhAccount from './locales/zh/account.json';
import enDashboard from './locales/en/dashboard.json';
import zhDashboard from './locales/zh/dashboard.json';
import enSession from './locales/en/session.json';
import zhSession from './locales/zh/session.json';
import enDataDownload from './locales/en/dataDownload.json';
import zhDataDownload from './locales/zh/dataDownload.json';
import enTeams from './locales/en/teams.json';
import zhTeams from './locales/zh/teams.json';
import enTutorialVideos from './locales/en/tutorialVideos.json';
import zhTutorialVideos from './locales/zh/tutorialVideos.json';
import enCommon from './locales/en/common.json';
import zhCommon from './locales/zh/common.json';
import enModal from './locales/en/modal.json';
import zhModal from './locales/zh/modal.json';

// Modify this value before deployment
// 'GLOBAL' - Global servers (English only)
// 'CN' - China servers (Supports English and Chinese language switching)
// Read server region from environment variable
const getServerRegion = () => {
  if (typeof import.meta !== 'undefined' && import.meta.env) {
    return import.meta.env.VITE_SERVER_REGION || 'GLOBAL'
  }
  if (typeof process !== 'undefined' && process.env) {
    return process.env.NEXT_PUBLIC_SERVER_REGION || 'GLOBAL'
  }
  return 'GLOBAL'
}

export const SERVER_REGION = getServerRegion()

const availableLanguages = SERVER_REGION === 'CN' ? ['en', 'zh'] : ['en'];
const defaultLanguage = SERVER_REGION === 'CN' ? 'zh' : 'en';

const resources = {
  en: {
    nav: enNav,
    auth: enAuth,
    account: enAccount,
    dashboard: enDashboard,
    session: enSession,
    dataDownload: enDataDownload,
    teams: enTeams,
    tutorialVideos: enTutorialVideos,
    common: enCommon,
    modal: enModal
  },
  zh: {
    nav: zhNav,
    auth: zhAuth,
    account: zhAccount,
    dashboard: zhDashboard,
    session: zhSession,
    dataDownload: zhDataDownload,
    teams: zhTeams,
    tutorialVideos: zhTutorialVideos,
    common: zhCommon,
    modal: zhModal
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: defaultLanguage,
    supportedLngs: availableLanguages,
    debug: false,
    ns: ['nav', 'auth', 'account', 'dashboard', 'session', 'dataDownload', 'teams', 'tutorialVideos', 'common', 'modal'],
    defaultNS: 'common',
    interpolation: {
      escapeValue: false
    },
    lng: defaultLanguage,
    react: {
      useSuspense: false
    }
  });

export default i18n;



